<div class="context-view">
  <div class="vehicle-schedule-container">
    @if (schedulerReady) {
      <dx-scheduler
        maxAppointmentsPerCell="unlimited"
        [dataSource]="appointments"
        [views]="views"
        [currentView]="viewName"
        [useDropDownViewSwitcher]="true"
        [currentDate]="fromDate"
        [height]="schedulerHeight"
        [startDayHour]="0"
        [endDayHour]="24"
        [cellDuration]="360"
        [groups]="['VehicleId']"
        [resources]="resources"
        (onAppointmentUpdating)="onAppointmentUpdating($event)"
        (onAppointmentDblClick)="onAppointmentDblClick($event)"
        (onAppointmentContextMenu)="onCellContextMenu($event)"
        (onCellContextMenu)="onCellContextMenu($event)"
        (onAppointmentFormOpening)="onAppointmentFormOpening($event)"
        (onOptionChanged)="onOptionChanged($event)"
        [showCurrentTimeIndicator]="true"
        [shadeUntilCurrentTime]="true"
        (onContentReady)="prepareToolbar()"
        [crossScrollingEnabled]="true"
        appointmentTemplate="appointmentTemplate"
        appointmentTooltipTemplate="appointmentTooltipTemplate"
        resourceCellTemplate="resourceCellTemplate"
        [ngStyle]="viewCompactStyles"
        (onAppointmentRendered)="onAppointmentRendered($event)"
        [ngClass]="{ 'dx-scheduler-loading': isLoading }"
        dateCellTemplate="dateCellTemplate"
        timeCellTemplate="timeCellTemplate"
        dataCellTemplate="dataCellTemplate">
        <dxo-editing [allowDeleting]="false"></dxo-editing>
        <dxo-appointment-dragging [onDragStart]="onDragStart"> </dxo-appointment-dragging>
        <div
          *dxTemplate="let cellData of 'dateCellTemplate'"
          [class.weekend]="cellData.date && (cellData.date.getDay() === 0 || cellData.date.getDay() === 6)">
          {{ cellData.date | date: 'EE dd.MM.yyyy' }}
        </div>
        <div
          *dxTemplate="let cellData of 'timeCellTemplate'"
          [class.weekend]="cellData.date && (cellData.date.getDay() === 0 || cellData.date.getDay() === 6)">
          {{ cellData.date | date: 'HH:mm' }}
        </div>
        <div
          *dxTemplate="let cellData of 'dataCellTemplate'"
          [class.weekend]="
            cellData.startDate && (cellData.startDate.getDay() === 0 || cellData.startDate.getDay() === 6)
          "></div>
        <ng-template #appointmentContent let-data>
          @if (data.isPrimeLogistic) {
            <app-badge-variant
              class="prime-logistic-badge"
              badge="none"
              label="PL"
              size="16"
              [shape]="Shape.Shield"
              backgroundColor="var(--prime-logistics-color-1)"
              [tooltip]="'ASSIGNMENT.INFOFILTER.PRIME_LOGISTIC' | translate" />
          }
          <span class="admin-project">
            {{ data.Administrator || '' }}
          </span>
          <span>
            <span class="dot">·</span>
            <span>
              {{ data.startDate | date: 'dd.MM HH:mm' }}-
              {{ data.endDate | date: 'dd.MM HH:mm' }}
            </span>
          </span>
          <span class="dot">·</span>
          <b
            class="project-id"
            tabindex="0"
            (click)="onProjectClick(data.ProjectNo)"
            (keyup.enter)="onProjectClick(data.ProjectNo)">
            [{{ data.ProjectNo || '' }}]
          </b>
          <span>
            <span class="dot">·</span>
            <span>
              {{ data.Driver || '' }}
            </span>
            @if (data.TrapoText) {
              <span class="dot">·</span>
            }
            <span>
              {{ data.TrapoText || '' }}
            </span>
            <span>
              @if (data.PickupVolume || data.DeliveryVolume) {
                <span class="dot">·</span>
              }
              @if (data.DeliveryVolume) {
                <span>
                  <img src="../../../assets/icons/AssignmentDelivery.svg" class="volume-icon" alt="Delivery volume" />
                  <span class="volume-item pickup">
                    {{ data.DeliveryVolume | number: '1.1-1' }}
                  </span>
                </span>
              }
              @if (data.PickupVolume) {
                <span>
                  <img src="../../../assets/icons/AssignmentPickup.svg" class="volume-icon" alt="Pickup volume" />
                  {{ data.PickupVolume | number: '1.1-1' }}
                </span>
              }
            </span>
          </span>
        </ng-template>
        <div *dxTemplate="let appointment of 'appointmentTemplate'">
          <div class="appointment-wrapper" [ngClass]="appointment.appointmentData.appointmentCssClass">
            @if (appointment.appointmentData.isWeekAppointment) {
              <div class="week-appointment" [style.background]="appointment.appointmentData.appointmentColor">
                <div class="appointment-content">
                  <div class="arrow-line">
                    <span class="arrow-head"></span>
                  </div>
                </div>
              </div>
            } @else {
              @if (!appointment.appointmentData.isAdminVisible && !showCompactView) {
                <div
                  class="appointment-content"
                  tabindex="0"
                  (click)="onTemplateClick($event, appointment.appointmentData)"
                  (keyup.enter)="onTemplateClick($event, appointment.appointmentData)">
                  <span class="admin-project">
                    {{ appointment.appointmentData.Administrator || '' }}
                  </span>
                  <span class="dot">·</span>
                  <b
                    class="project-id"
                    tabindex="0"
                    (click)="onProjectClick(appointment.appointmentData.ProjectNo)"
                    (keyup.enter)="onProjectClick(appointment.appointmentData.ProjectNo)">
                    [{{ appointment.appointmentData.ProjectNo || '' }}]
                  </b>
                </div>
              } @else {
                <div
                  class="appointment-content"
                  tabindex="0"
                  (click)="onTemplateClick($event, appointment.appointmentData)"
                  [style.background]="appointment.appointmentData.appointmentColor"
                  (keyup.enter)="onTemplateClick($event, appointment.appointmentData)">
                  @if (!showCompactView) {
                    <ng-container
                      *ngTemplateOutlet="appointmentContent; context: { $implicit: appointment.appointmentData }">
                    </ng-container>
                  }
                </div>
                <div
                  class="loadunits-container"
                  [style.background-color]="
                    appointment.appointmentData.loadunitsContainerColor || appointment.appointmentData.appointmentColor
                  ">
                  @if (!showCompactView) {
                    @for (loadunit of appointment.appointmentData.formattedLoadunits; track loadunit) {
                      <span class="loadunit-arrow" [class.pickup]="loadunit.isPickup">➔</span>
                      <span class="loadunit-city">
                        {{ loadunit.city }}
                      </span>
                    }
                  }
                </div>
              }
            }
          </div>
        </div>
        <div *dxTemplate="let resource of 'resourceCellTemplate'">
          <div class="resource-cell" #vehicleName>
            <div class="driver-name" [id]="resource.data.id">
              {{ resource.data.text }}
              <dx-tooltip [target]="vehicleName" [showEvent]="'mouseenter'" [hideEvent]="'mouseleave'" position="top">
                <div>
                  {{ resource.data.text }}
                </div>
              </dx-tooltip>
            </div>
            <div class="week-info">
              @if (resource.data.driver?.weekStart) {
                <div>L: {{ resource.data.driver?.weekStart | date: 'dd.MM.yyyy' }}</div>
              }
              @if (resource.data.driver?.weekStartShort) {
                <div>K: {{ resource.data.driver?.weekStartShort | date: 'dd.MM.yyyy' }}</div>
              }
            </div>
          </div>
        </div>
        <div *dxTemplate="let model of 'appointmentTooltipTemplate'">
          <dx-scroll-view direction="horizontal" maxwidth="400" class="tooltip-scroll">
            @if (model.appointmentData.isWeekAppointment) {
              <div class="tooltip-content">
                {{ model.appointmentData.AppointmentType | translate }}
              </div>
            } @else {
              <div class="tooltip-content">
                <ng-container *ngTemplateOutlet="appointmentContent; context: { $implicit: model.appointmentData }">
                </ng-container>
              </div>
              <div class="tooltip-loadunits">
                @for (loadunit of model.appointmentData.formattedLoadunits; track loadunit) {
                  <span class="loadunit-arrow" [class.pickup]="loadunit.isPickup">➔</span>
                  <span class="loadunit-city">
                    {{ loadunit.city }}
                  </span>
                }
              </div>
            }
          </dx-scroll-view>
        </div>
        <dxo-scrolling [mode]="showCompactView ? 'standard' : 'virtual'"></dxo-scrolling>
      </dx-scheduler>
    }
    <dx-context-menu
      [items]="contextMenuItems"
      [(visible)]="contextMenuVisible"
      [width]="200"
      target=".dx-scheduler-date-table-container"
      (onItemClick)="onContextMenuItemClick($event)">
    </dx-context-menu>
    <app-loader [hide]="!isLoading && !isRepainting"></app-loader>
  </div>
</div>
